import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostFile } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const SupportChatQueryAction = createAsyncThunk("supportChatQuery",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPostFile(urls?.query, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const SupportChatQuerySlice = createSlice({
    name: "supportChatQuery",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        SupportChatQueryReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [SupportChatQueryAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [SupportChatQueryAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [SupportChatQueryAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { SupportChatQueryReset } = SupportChatQuerySlice.actions
